import {Stack, Typography, Button} from "@mui/material";

export const LicenseRejected = ({onGoHome}: {onGoHome: () => void}) => {

    return (
        <Stack maxWidth="816px" padding="3rem" alignItems="center" spacing={4}>
            <Typography variant="body1" textAlign="center">
              Без принятия лицензии не можем зарегистрировать вас в системе.
            </Typography>
            <Button size="large" variant="contained" onClick={onGoHome}>
                На главную
            </Button>
        </Stack>
    );
};
